import { CATEGORY_GET } from './categoryActionTypes';
import departmentsLinksArray from '../../data/headerDepartments';

function getDepLinks(categories) {
  categories.forEach(cat => {
    const child_list = cat.children || [];
    // Ищем в статиках пункт с таким же названием
    const dept = departmentsLinksArray.find(x => x.title === cat.name);
    if (!dept) return;
    // Присваиваем url для родительского пункта
    dept.url = cat.id;
    // Обрабатываем меню подкатегорий
    if (dept.subcategory && Array.isArray(dept.subcategory.menu)) {
      dept.subcategory.menu.forEach(subItem => {
        const child = child_list.find(x => x.name === subItem.title);
        if (child) {
          subItem.url = child.id;
        }
      });
    }
  });
  return departmentsLinksArray;
}

export default function categoryReducer(state = [], action) {
  switch (action.type) {
    case CATEGORY_GET: {
      let cats = action.payload;
      // если пришёл единственный ROOT-узел – берем его children
      if (
        Array.isArray(cats) &&
        cats.length === 1 &&
        cats[0].id === 'ROOT' &&
        Array.isArray(cats[0].children)
      ) {
        cats = cats[0].children;
      }
      return getDepLinks(cats);
    }

    default:
      return state;
  }
}
